import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'

const PrivateRoutes = () => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  const ShopifyUser = lazy(() => import('../modules/apps/shopify-connect/shopify-user'))

  const SourcesPage = lazy(() => import('../modules/apps/sources-management/SourcesPage'))


  const DestinationsPage = lazy(() => import('../modules/apps/Destinations/DestinationsPage'))
  const ConnectionPage = lazy(() => import('../modules/apps/Connection/ConnectionPage'))

  const OrderhistoryPage = lazy(() => import('../modules/apps/orderhistory/OrderhistoryPage'))
  const CustomerhistoryPage = lazy(() => import('../modules/apps/customerhistory/CustomerhistoryPage'))
  const TrackingorderhistoryPage = lazy(() => import('../modules/apps/trackingorderhistory/TrackingorderhistoryPage'))
  const ConsoleconnectPage = lazy(() => import('../modules/apps/consoleconnect/ConsoleconnectPage'))
  const ConsoleconnectCronlogPage = lazy(() => import('../modules/apps/consoleconnectCronlog/ConsoleconnectCronlogPage'))

  const ConsoleconnecthistoryPage = lazy(() => import('../modules/apps/consoleconnecthistory/ConsoleconnecthistoryPage'))
  const ConsoleconnectCronloghistoryPage = lazy(() => import('../modules/apps/consoleconnectCronloghistory/ConsoleconnectCronloghistoryPage'))
  const WebhookPage = lazy(() => import('../modules/apps/webhook/WebhookPage'))
  const OrderDetailPage = lazy(() => import('../modules/apps/orderhistory/OrderhistoryPage'))

  const ConnectorQueueDashboardPage = lazy(() => import('../modules/apps/connectorQueueDashboard/ConnectorQueueDashboardPage'))

  const ProductListPage = lazy(() => import('../modules/apps/product-management/product-list/ProductListPage'))
  const ProductDetailPage = lazy(() => import('../modules/apps/product-management/product-detail/ProductDetailPage'))
  const ShopeeProductPage = lazy(() => import('../modules/apps/product-management/product-shopee/ProductShopeePage'))
  const ProductSyncLogPage = lazy(() => import('../modules/apps/product-management/product-sync-log/ProductSyncLogPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/apps/connector-queue-management/connector-queue' />} />


        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />




        <Route
          path='apps/destinations-management/*'
          element={
            <SuspensedView>
              <DestinationsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/connection-management/*'
          element={
            <SuspensedView>
              <ConnectionPage />
            </SuspensedView>
          }
        />




        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/shopify-connect/*'
          element={
            <SuspensedView>
              <ShopifyUser />
            </SuspensedView>
          }
        />

        

        <Route
          path='apps/sources-management/*'
          element={
            <SuspensedView>
              <SourcesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/orderhistory-management/*'
          element={
            <SuspensedView>
              <OrderhistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/customerhistory-management/*'
          element={
            <SuspensedView>
              <CustomerhistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/trackingorderhistory-management/*'
          element={
            <SuspensedView>
              <TrackingorderhistoryPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/consoleconnect-management/*'
          element={
            <SuspensedView>
              <ConsoleconnectPage />
            </SuspensedView>
          }
        />
        <Route
        path='apps/consoleconnectcronlog-management/*'
        element={
          <SuspensedView>
            <ConsoleconnectCronlogPage />
          </SuspensedView>
        }
      />

        <Route
          path='apps/consoleconnecthistory-management/*'
          element={
            <SuspensedView>
              <ConsoleconnecthistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/consoleconnectcronloghistory-management/*'
          element={
            <SuspensedView>
              <ConsoleconnectCronloghistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/webhook-management/*'
          element={
            <SuspensedView>
              <WebhookPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/orderhistory-management/order-detail/*'
          element={
            <SuspensedView>
              <OrderDetailPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/connector-queue-management/*'
          element={
            <SuspensedView>
              <ConnectorQueueDashboardPage />
            </SuspensedView>
          }
        />

        {/* Product Management */}
        <Route 
          path='apps/product-management/product-list/*'
          element={ 
            <SuspensedView>
              <ProductListPage />
            </SuspensedView>
          }
        />
        
        <Route
          path='apps/product-management/product/:id'
          element={
            <SuspensedView>
              <ProductDetailPage />
            </SuspensedView> 
          } 
        />
        
        <Route
          path='apps/product-management/product-shopee/*'
          element={ 
            <SuspensedView>
              <ShopeeProductPage />
            </SuspensedView> 
          } 
        />
        
        <Route
          path='apps/product-management/product-sync-log/*'
          element={
            <SuspensedView>
              <ProductSyncLogPage />
              </SuspensedView>
          }
        />
        {/* End Product Management */}   

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
